import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AccountsProfile } from "./types";

export const getUserProfileRequest = (userId: string) =>
  apiProxyRequest<AccountsProfile>(`/profiles/${userId}`);
